import InvoiceServiceContract from './InvoiceServiceContract';

export default InvoiceServiceContract;